export const getEditedTxns = (transactions) => {
	return transactions.filter((txn) => {
		return (txn.is_original && !txn.is_edited) || (txn.is_manual && !txn.is_journal);
	})
}

export const getNeedsReviewTxns = (transactions) => {
	const loggedInEmail = localStorage.getItem("psg_last_login");
	return transactions.filter((txn) => {
		return txn.editor !== "" && txn.editor !== loggedInEmail && txn.approver === "";
	})
}

export const needsReviewCount = (transactions) => {
	const transactionsCount = getNeedsReviewTxns(transactions).length;
	return transactionsCount;
};

export const getOriginalTxns = (transactions) => {
	return transactions.filter((txn) => txn.is_original);
};

export const transactionsKindChangeHelper = (
  { transactionsKind=[], originalTransactions=[], editedTransactions=[], needsReviewTransactions=[], transactions=[], calculated=true }
  ) => {
	switch(transactionsKind) {
		case "Original":
		  return calculated ? originalTransactions : getOriginalTxns(transactions);
		case "Edited":
		  return calculated ? editedTransactions : getEditedTxns(transactions);
		case "Needs Review":
		  return calculated ? needsReviewTransactions : getNeedsReviewTxns(transactions);
		default:
		  console.error(`Invalid transactions kind: ${transactionsKind}`);
		  return [];
	}
};
